import React from "react"
import LogoutIcon from "@mui/icons-material/Logout";
import {Divider, IconButton, Menu, MenuItem} from "@mui/material";
import AccountCircleIcon from '@mui/icons-material/AccountCircle';
import './AccountMenu.css';
import {selectGuiState} from "../../Redux/gui";
import {useSelector} from "react-redux";
import {useKeycloak} from "../../Keycloak/useKeycloak";

const AccountMenu = () => {
    const [anchorEl, setAnchorEl] = React.useState<null | HTMLElement>(null);
    const open = Boolean(anchorEl)

    const {keycloak} = useKeycloak()

    const handleClick = (event: React.MouseEvent<HTMLElement>) => setAnchorEl(event.currentTarget)
    const handleClose = () => setAnchorEl(null)

    const logout = async () => {
        keycloak?.logout()
        handleClose()
    }

    const state = useSelector(selectGuiState)

    return(
        <React.Fragment>
            <IconButton
                className={'items-center'}
                onClick={handleClick}
                aria-controls={open ? 'account-menu' : undefined}
                aria-haspopup="true"
                aria-expanded={open ? 'true' : undefined}
            >
                <AccountCircleIcon />
            </IconButton>
            <Menu
                anchorEl={anchorEl}
                id="account-menu"
                open={open}
                onClose={handleClose}
                onClick={handleClose}
                transformOrigin={{ horizontal: 'right', vertical: 'top' }}
                anchorOrigin={{ horizontal: 'right', vertical: 'bottom' }}
            >
                <MenuItem onClick={handleClose} className={"MenuItem"}>
                    <AccountCircleIcon className={"MenuIcon"} /> {state.user_email}
                </MenuItem>
                <Divider />
                <MenuItem onClick={logout} className={"MenuItem"}>
                    <LogoutIcon className={"MenuIcon"} /> Logout
                </MenuItem>
            </Menu>
        </React.Fragment>
    )
}

export {AccountMenu}